import { useState } from 'react';

export interface UseGenericProps<T> {
  data: T | T[];
}

export const useGeneric = <T>({ data }: UseGenericProps<T>) => {
  const [genericData, setGenericData] = useState<T | T[]>(data);

  return { genericData, setGenericData };
};

export default useGeneric;
